export const rulesMessages = {
  required: 'This field is required.',
  str: {
    min: (num: number) => `Ensure this field has at least ${num} characters.`,
    max: (num: number) =>
      `Ensure this field has no more than ${num} characters.`
  },
  num: {
    max: (num: number) => `Ensure this value is less than or equal to ${num}.`,
    min: (num: number) =>
      `Ensure this value is greater than or equal to ${num}.`
  },
  unique: 'Please enter unique values.'
}

export const defaultErrorMessages = {
  string: {
    max: (_: unknown, max: number) =>
      `Ensure this field has no more than ${max} characters.`
  },
  required: rulesMessages.required
}

export const DEFAULT_ERROR_MESSAGE = 'An error occurred. Try again later'
